module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai380-0332cbf9a9617aeb9f911874af5aea1d.jpg";